import { render, staticRenderFns } from "./StatisticsChart.vue?vue&type=template&id=3259ee0a&"
import script from "./StatisticsChart.vue?vue&type=script&lang=ts&"
export * from "./StatisticsChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3259ee0a')) {
      api.createRecord('3259ee0a', component.options)
    } else {
      api.reload('3259ee0a', component.options)
    }
    module.hot.accept("./StatisticsChart.vue?vue&type=template&id=3259ee0a&", function () {
      api.rerender('3259ee0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StatisticsChart.vue"
export default component.exports